import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import ReactMarkdown from 'react-markdown';
import '../pages/StockIndexPage.css'

export default function StockIndexPage({ onBack, onNavigate }) {
  const [summaryText, setSummaryText] = useState('');
  const summaryTextURL = process.env.PUBLIC_URL + '/content/individual_page_intros/StockForecastingPage__intro.md';

  useEffect(() => {
    fetch(summaryTextURL)
      .then(res => res.text())
      .then(setSummaryText)
      .catch(console.error);
  }, [summaryTextURL]);

  return (
    <>
      <Helmet>
        <title>Stock Index Forecasting | Insight Data LLC</title>
      </Helmet>

      <div className='si-home-container'>
        <div className='si-image-credit'>
          Background image by Pixabay
        </div>
        <div className='si-tile-box'>
          <div className='si-back-button'>
            <button onClick={onBack} className="back-link">
               Back to Economic Analysis Projects
            </button>
          </div>

          <h1 style={{ fontSize: '2.5rem', marginBottom: '0.5rem', color: '#222' }}>
            Stock Index Forecasting With Regressors
          </h1>

          <div className='si-button'>
            <button onClick={() => onNavigate({ section: 'graph', symbol: 'sp500' })}>
              View S&amp;P 500 Forecast
            </button>
          </div>

          <div className='si-button'>
            <button onClick={() => onNavigate({ section: 'graph', symbol: 'nasdaq' })}>
              View NASDAQ Forecast
            </button>
          </div>

          <div className="si-project-description">
            <ReactMarkdown>
              {summaryText}
            </ReactMarkdown>
          </div>

          <div style={{ textAlign: 'right', marginTop: '1rem' }}>
            <a
              href="https://github.com/jakobjgu/stock_forecasting_pipeline"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#0039A6', fontSize: '0.875rem' }}
            >
              View GitHub Repo
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
